(() => {
  const ALIAS_DATA_SELECTOR = '[data-cardology-search-aliases]';
  const MAIN_SEARCH_SELECTOR = '.csr';

  const normalise = (value = '') => String(value)
    .toLowerCase()
    .replace(/&amp;/g, ' and ')
    .replace(/['’]s\b/g, 's')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const readAliases = () => {
    const aliases = {};

    document.querySelectorAll(ALIAS_DATA_SELECTOR).forEach((element) => {
      try {
        const parsed = JSON.parse(element.textContent || '{}');
        Object.entries(parsed).forEach(([trigger, target]) => {
          const key = normalise(trigger);
          const cleanTarget = String(target || '').trim();
          if (key && cleanTarget) aliases[key] = cleanTarget;
        });
      } catch (error) {
        console.warn('Cardology search aliases: unable to parse alias data.', error);
      }
    });

    return aliases;
  };

  const aliases = readAliases();

  const resolveAlias = (query) => {
    const original = String(query || '').trim();
    const target = aliases[normalise(original)] || '';

    return {
      original,
      target,
      isAlias: Boolean(original && target && normalise(target) !== normalise(original)),
    };
  };

  const buildMappedSearchUrl = (searchUrl, original, target, currentUrl = null) => {
    const url = currentUrl
      ? new URL(currentUrl, window.location.origin)
      : new URL(searchUrl || '/search', window.location.origin);

    url.searchParams.set('q', target);
    url.searchParams.set('type', url.searchParams.get('type') || 'product');
    url.searchParams.set('options[prefix]', url.searchParams.get('options[prefix]') || 'last');
    url.searchParams.set('cdo_alias', original);
    return url.toString();
  };

  const isPredictiveSearchUrl = (url) => {
    try {
      const parsed = new URL(typeof url === 'string' ? url : url.url, window.location.origin);
      return parsed.pathname.includes('/search/suggest');
    } catch (error) {
      return false;
    }
  };

  const nativeFetch = window.fetch.bind(window);

  window.fetch = (input, init) => {
    if (!isPredictiveSearchUrl(input)) return nativeFetch(input, init);

    try {
      const originalUrl = new URL(typeof input === 'string' ? input : input.url, window.location.origin);
      const query = originalUrl.searchParams.get('q') || '';
      const resolved = resolveAlias(query);

      if (!resolved.isAlias) return nativeFetch(input, init);

      originalUrl.searchParams.set('q', resolved.target);

      if (typeof input === 'string') return nativeFetch(originalUrl.toString(), init);
      return nativeFetch(new Request(originalUrl.toString(), input), init);
    } catch (error) {
      return nativeFetch(input, init);
    }
  };

  const getVisibleHeaderSearchInput = (overlay) => {
    if (!overlay) return null;
    return Array.from(overlay.querySelectorAll('[data-cdo-search-input]'))
      .find((input) => input.offsetParent !== null) || overlay.querySelector('[data-cdo-search-input]');
  };

  const handleHeaderSearchSubmit = (event) => {
    const form = event.target.closest?.('[data-cdo-search-form]');
    if (!form) return;

    const overlay = form.closest('[data-cdo-search-overlay]');
    const input = form.querySelector('[data-cdo-search-input]') || getVisibleHeaderSearchInput(overlay);
    const query = input?.value?.trim() || '';
    const resolved = resolveAlias(query);
    if (!resolved.isAlias) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const searchUrl = overlay?.dataset.cdoSearchUrl || '/search';
    window.location.assign(buildMappedSearchUrl(searchUrl, resolved.original, resolved.target));
  };

  const handleHeaderSearchResultLink = (event) => {
    const link = event.target.closest?.('[data-cdo-search-results] .cdo-header__trending-head > a, [data-cdo-search-results] .cdo-search__primary-cta');
    if (!link) return;

    const overlay = link.closest('[data-cdo-search-overlay]');
    const input = getVisibleHeaderSearchInput(overlay);
    const query = input?.value?.trim() || '';
    const resolved = resolveAlias(query);
    if (!resolved.isAlias) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const searchUrl = overlay?.dataset.cdoSearchUrl || '/search';
    window.location.assign(buildMappedSearchUrl(searchUrl, resolved.original, resolved.target));
  };

  const preserveAliasOnSearchLinks = (root, originalAlias) => {
    if (!root || !originalAlias) return;

    root.querySelectorAll('.csr-toolbar__pill, .csr-toolbar__clear, .csr-pagination a').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('cdo_alias', originalAlias);
        link.href = url.toString();
      } catch (error) {
        // Leave malformed or non-search URLs unchanged.
      }
    });
  };

  const updateMainSearchDisplay = (root, originalAlias) => {
    if (!root || !originalAlias) return;

    const headingTerm = root.querySelector('.csr-hero h1 span');
    const searchInput = root.querySelector('#Search-In-Template');

    if (headingTerm) headingTerm.textContent = `“${originalAlias}”`;
    if (searchInput) searchInput.value = originalAlias;

    preserveAliasOnSearchLinks(root, originalAlias);
  };

  const resolveInitialMainSearch = () => {
    const root = document.querySelector(MAIN_SEARCH_SELECTOR);
    if (!root) return;

    const currentUrl = new URL(window.location.href);
    const currentQuery = currentUrl.searchParams.get('q') || '';
    const originalAlias = currentUrl.searchParams.get('cdo_alias') || '';

    if (originalAlias) {
      updateMainSearchDisplay(root, originalAlias);
      return;
    }

    const resolved = resolveAlias(currentQuery);
    if (!resolved.isAlias) return;

    window.location.replace(
      buildMappedSearchUrl('/search', resolved.original, resolved.target, currentUrl.toString())
    );
  };

  const handleMainSearchSubmit = (event) => {
    const form = event.target.closest?.('.csr-search form');
    if (!form) return;

    const input = form.querySelector('input[name="q"]');
    const query = input?.value?.trim() || '';
    const resolved = resolveAlias(query);
    if (!resolved.isAlias) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(buildMappedSearchUrl(form.action || '/search', resolved.original, resolved.target));
  };

  document.addEventListener('submit', handleHeaderSearchSubmit, true);
  document.addEventListener('submit', handleMainSearchSubmit, true);
  document.addEventListener('click', handleHeaderSearchResultLink, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resolveInitialMainSearch, { once: true });
  } else {
    resolveInitialMainSearch();
  }
})();